import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { TPdeviationReportModel } from '../../model'
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ExcelService } from '../../exceldownloader';
import * as $ from 'jquery';
import { Subscription } from 'rxjs'; 

@Component({
    selector: 'app-tpdeviationreport',
    template: require('./tpdeviationreport.component.html'),
    styles: []
})
export class TPDeviationReportComponent implements OnInit {
    formgroup: FormGroup;
    EmpDetails: any;
    ManagerList: any;
    headQuarterList: any;
    employeeData: any = [];
    private columnDefs;
    private rowData;
    private rowHeight;
    api: any;
    busy: Subscription;
    api1: any;
    columnApi: any;
    columnApi1: any;
    columnDefsPopup: any;
    defaultColDefine;
    defaultColDef;
    private gridColumnApi;
    private gridColumnApi1;
    private detailCellRendererParams;
    currentMonth: any;
    staffTypes: any;
    staff: any;
    designation: any;
    currentDate: any;
    token:any;
    TPdeviationReport_Form = new FormGroup({
        ManagerID: new FormControl('', [Validators.required]),
        userId: new FormControl('', [Validators.required]),
        currentMonth: new FormControl('', [Validators.required]),
        HQ: new FormControl('', [Validators.required]),

    });
    TPdeviationReportModel: TPdeviationReportModel = new TPdeviationReportModel();
    static parameters = [ApiService, Router, HttpClient, ToastrService, ExcelService]
    constructor(
        private apiService: ApiService, private router: Router, private http: HttpClient, private toast: ToastrService, private ExcelService: ExcelService

    ) {
        let parent = this;
        this.columnDefs = [
            { headerName: 'S.No.', valueGetter: "node.rowIndex + 1", width: 90 },
            { headerName: 'Employee Code', field: 'Client_Code' },
            {
                headerName: 'Employee Name', field: "Client_Name", cellRenderer: function (params) {
                    var eDiv = document.createElement('div');
                    eDiv.innerHTML = `
                      <div class="grid_actions">
                          <span class="grid_actions_item" data-target="#EmployeeRecordDetails" data-toggle="modal"><a class="viewBtn btn btn-link">`+ params.data.Client_Name + `</a></span>
                      </div>
                      `;
                    var viewButton = eDiv.querySelectorAll('.viewBtn')[0];
                    viewButton.addEventListener('click', function () {
                        parent.tracking(params.data);
                    });
                    return eDiv;
                }
            },
            { headerName: 'Manager', field: "Manager" },

            { headerName: 'Head Qtr.', field: "HQName" },
            { headerName: 'Designation.', field: "Designation" },
            { headerName: 'Submit Date.', field: "SubmitDate" },

        ];
        // this.columnDefs = [
        //      { headerName: 'S.No.', valueGetter: "node.rowIndex + 1", width: 80 },
        //     { headerName: 'Employee Code', field: "Client_Code" },
        //     {
        //         headerName: 'Emp. Name', field: "Client_Name", pinned: "left", suppressFilter: true, cellRenderer: 'agGroupCellRenderer'
        //     },
        //     { headerName: 'Manager', field: "Manager" },
        //     { headerName: 'Designation', field: "Designation" },
        //     { headerName: 'HQName', field: "HQName" },
        //     { headerName: 'Submit Date', field: "SubmitDate" },

        // ];
        this.columnDefsPopup = [
            { headerName: 'S.No.', valueGetter: "node.rowIndex + 1", width: 90 },
            { headerName: 'Date', field: 'PlanDate' },
            {
                headerName: ' Route as Per TP', field: "RouteASTP", width: 350
            },
            {
                headerName: 'Deviated Route', field: "DeviatedRoute"
            },
            {
                headerName: ' DA Type', field: "DAType"
            },
            {
                headerName: ' Reason for Divert', field: "ReasonForRouteDivert"
            },
            {
                headerName: ' Total Retailer Call', field: "TotalRetailerCall"
            }
        ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };
        this.defaultColDef = { resizable: true };

    }
    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        $('#filter-option').trigger('click');
        this.TPdeviationReportModel.ManagerID = 0;
        this.TPdeviationReportModel.userId = '0';
        this.TPdeviationReportModel.HQ = 0;
        var date = new Date();
        this.currentDate = date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, "0");
        // this.currentMonth = this.currentDate;
        this.TPdeviationReportModel.currentMonth = this.currentDate;
        this.getManagerDetails();
        this.getEmpDetails();
        this.getHeadQuarterList();
    }
    // onBtnExport() {
    //     this.api.exportDataAsExcel({ fileName: 'TP_Deviation_Report' });
    // }

    getHeadQuarterList() {
        this.apiService.getHeadQuarterList().subscribe((res: any) => {
            this.headQuarterList = res.data;
        })
    }

    getManagerDetails() {
        var data = {
            Id: this.token.id
        };
        this.http.post('/api/Report/getManagerListForLogUnLog',data)
            .subscribe(res => {
                this.ManagerList = res;
            });
    }

    getEmpDetails() {
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        //  console.log('token', token);
        var data = {
            Id: token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.EmpDetails = res.data;
            console.log('empDetails', this.EmpDetails);
        })
    }
    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
        this.api.refreshCells();
    }

    tracking(data) {
        //this.api1.showLoadingOverlay();
        var queryData = {
            date: this.TPdeviationReport_Form.value.currentMonth,
            EmpId: data.EmpID,

        }
        this.employeeData = [];
        console.log(queryData);
       this.busy = this.apiService.GetTPDeviatedEmployeeDetails(queryData)
            .subscribe((res: any) => {
                this.employeeData = res.data;
            })

    }
    filterData() {
        //this.api.showLoadingOverlay();
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.TPdeviationReportModel.empId = token.id;
        this.busy = this.apiService.GetTPDeviationEmployeeList(this.TPdeviationReportModel).subscribe((res: any) => {
            this.rowData = res.data;
        })

    }
    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.hideOverlay();
    }
    onGridReady1 = (params) => {
        this.api1 = params.api;
        this.gridColumnApi1 = params.columnApi;
        this.api1.hideOverlay();
        // this.api1.showNoRowsOverlay();
    }
    
    ExportTPDeviationReport() {
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.TPdeviationReportModel.empId = token.id;
        this.busy = this.apiService.GetTPDeviationReportForExport(this.TPdeviationReportModel).subscribe((res: any) => {
            var exportdata = res.data;
            this.ExcelService.exportAsExcelFile(exportdata, 'TP_Deviation_Report');
        })
    }
}
